import { io } from 'socket.io-client';
import { API_BASE } from './utils/api';
const socket = io(API_BASE.replace('/api', ''), {
  transports: ['websocket'],
  path: '/socket.io' // default, but okay to be explicit
});
socket.on('connect', () => {});
socket.on('connect_error', err => {
  console.error('❌ Socket connection error:', err);
});
export default socket;